import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './InstitutionsFinalCTASection.module.css';

export function InstitutionsFinalCTASection() {
  return (
    <SectionWrapper background="navy" data-testid="institutions-section-final-cta">
      <div className={styles.section}>
        <h2 className={styles.title}>Start with one conversation.</h2>
        <p className={styles.subhead}>
          We can map your current courseware stack, identify the easiest pilot,
          and show what inclusive access looks like at $25 per student.
        </p>
        <PrimaryCTA
          className={styles.cta}
          href="/contact"
          icon={<ArrowRight aria-hidden="true" size={16} />}
          label="Start a conversation"
        />
        <p className={styles.note}>
          Prefer email? <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </div>
    </SectionWrapper>
  );
}
